
// ERP API Configuration
export const API_CONFIG = {
  baseURL: '', // Will be filled dynamically with user configuration
  apiKey: '', // Will be filled dynamically with user configuration
  token: '', // Added token property for HeaderToken
  timeout: 30000, // Timeout in ms for requests
  useCorsProxy: false, // Option to use CORS proxy
  corsProxyURL: 'https://corsproxy.io/?', // CORS proxy URL
  
  // Endpoints
  endpoints: {
    // Autenticação
    auth: {
      login: '/api/PessoaVendedors/LogarApp',
    },
    // Produtos
    products: {
      list: '/api/GenericIntegrations/GetProdutos',
      byId: '/api/GenericIntegrations/GetProduto/:id',
      sync: '/api/GenericIntegrations/GetProdutos', // Endpoint para sincronização completa
    },
    // Categorias
    categories: {
      list: '/api/GenericIntegrations/Categorias',
      byId: '/api/GenericIntegrations/Categoria/:id',
    },
    // Pedidos
    orders: {
      list: '/api/pedidos',
      create: '/api/pedidos',
      update: '/api/pedidos/:id',
      byId: '/api/pedidos/:id',
      sync: '/api/pedidos/sincronizar', // Endpoint para sincronização completa
      syncOrder: '/api/vendas/SalvarOuAtualizarVendaApp', // Novo endpoint para sincronização de vendas
    },
    // Formas de Pagamento
    paymentMethods: {
      list: '/api/FormaPagamentoes',
      byId: '/api/FormaPagamentoes/:id',
    },
    // Usuários/Funcionários
    users: {
      list: '/api/usuarios',
      byId: '/api/usuarios/:id',
      authenticate: '/api/usuarios/autenticar',
      sync: '/api/usuarios/sincronizar', // Endpoint para sincronização completa
    },
    // Add customers endpoints
    customers: {
      list: '/api/PessoaClientesApi',
      byId: '/api/PessoaClientesApi/:id'
    }
  },
  
  // Allowed CORS domains
  allowedDomains: [
    'primeconveniencia.rspcloud.com.br',
    'restaurante.rspcloud.com.br'
  ],
  
  // Get full URL based on current domain
  getFullUrl: function(endpoint: string) {
    // Se já temos uma URL base completa, usar ela
    if (this.baseURL) {
      return `${this.baseURL}${endpoint}`;
    }
    
    // Tentar criar uma URL usando o domínio atual
    const currentDomain = window.location.hostname;
    
    // Verificar se estamos em ambiente de desenvolvimento local
    const isDevelopment = currentDomain === 'localhost' || currentDomain.includes('127.0.0.1');
    
    // Se estamos em um subdiretório do domínio principal
    const isInSubdirectory = window.location.pathname.includes('/restaurante/');
    
    // Se estamos em algum dos domínios permitidos
    for (const domain of this.allowedDomains) {
      if (currentDomain.includes(domain) || domain.includes(currentDomain)) {
        // Construir URL baseada no protocolo atual
        const protocol = window.location.protocol;
        
        // Se estamos no subdiretório /restaurante/ dentro do domínio principal,
        // não precisamos adicionar o domínio, podemos usar caminhos relativos
        if (isInSubdirectory && currentDomain.includes('primeconveniencia.rspcloud.com.br')) {
          // Use path relativo para evitar CORS
          return endpoint;
        }
        
        return `${protocol}//${domain}${endpoint}`;
      }
    }
    
    // Em desenvolvimento local, se não tiver URL base configurada, não podemos fazer requests
    if (isDevelopment && !this.baseURL) {
      console.warn('API URL não configurada em ambiente de desenvolvimento local. Configure em Configurações > API.');
    }
    
    // Voltar para URL base padrão
    return `${this.baseURL}${endpoint}`;
  },
  
  // Initialize API with settings
  initialize: function() {
    try {
      // Load from localStorage
      this.baseURL = localStorage.getItem('api_base_url') || '';
      
      console.log('API_CONFIG initializing with base URL:', this.baseURL);
      
      // IMPORTANT: Check for HeaderToken first (the one used in C# example), then fallback to other tokens
      this.apiKey = localStorage.getItem('HeaderToken') || '';
      if (!this.apiKey) {
        this.apiKey = localStorage.getItem('api_auth_token') || '';
      }
      if (!this.apiKey) {
        this.apiKey = localStorage.getItem('api_key') || '';
      }
      
      // Set the token property for consistency
      this.token = this.apiKey;
      
      // Decrypt the token if it's encrypted (base64)
      if (this.apiKey) {
        try {
          this.apiKey = atob(this.apiKey);
          this.token = this.apiKey; // Also update token with decrypted value
          console.log('API token loaded and decrypted successfully, length:', this.apiKey.length);
        } catch (e) {
          // If decryption fails, it might not be encrypted
          console.log('API token decryption failed, using as-is');
        }
      }
      
      this.useCorsProxy = localStorage.getItem('use_cors_proxy') === 'true';
      
      // Verify authentication tokens available
      if (!this.apiKey) {
        console.warn('No API token found. API requests may fail.');
      } else {
        console.log('API token loaded successfully, length:', this.apiKey.length);
      }
      
      // Try to encode the URL to prevent pattern-matching errors
      if (this.baseURL) {
        try {
          // Test if the URL is valid
          new URL(this.baseURL);
        } catch (error) {
          console.error('Invalid API URL format:', this.baseURL);
          this.baseURL = ''; // Reset to prevent errors
        }
      }
      
      // Detecção automática se estamos no mesmo domínio/subdiretório
      const currentDomain = window.location.hostname;
      const isInSubdirectory = window.location.pathname.includes('/restaurante/');
      
      if (!this.baseURL && currentDomain.includes('primeconveniencia.rspcloud.com.br')) {
        // Se estamos hospedados no domínio do ERP, usar URL relativa
        this.baseURL = 'https://primeconveniencia.rspcloud.com.br';
        // Não precisamos de proxy CORS quando estamos no mesmo domínio
        this.useCorsProxy = false;
        
        console.log('Detectado que estamos no domínio do ERP, usando URLs absolutas');
      } else if (isInSubdirectory && currentDomain.includes('primeconveniencia.rspcloud.com.br')) {
        // Se estamos no subdiretório, temos que usar URLs relativas
        this.baseURL = '';
        this.useCorsProxy = false;
        
        console.log('Detectado que estamos no subdiretório do ERP, usando URLs relativas');
      } else if (currentDomain === 'localhost' || currentDomain.includes('127.0.0.1')) {
        console.log('Ambiente de desenvolvimento local detectado');
        // Em desenvolvimento local, mantenha as configurações do usuário
      }
      
      // Se ainda não temos um baseURL, tentar buscar do domínio
      if (!this.baseURL) {
        for (const domain of this.allowedDomains) {
          if (currentDomain.includes(domain)) {
            this.baseURL = `https://${domain}`;
            console.log(`Configurando baseURL automaticamente para: ${this.baseURL}`);
            break;
          }
        }
      }
      
      console.log('API Config initialized:', {
        baseURL: this.baseURL,
        hasApiKey: !!this.apiKey,
        tokenLength: this.apiKey ? this.apiKey.length : 0,
        useCorsProxy: this.useCorsProxy,
        path: window.location.pathname,
        domain: window.location.hostname
      });
      
      return { 
        baseURL: this.baseURL, 
        apiKey: this.apiKey,
        token: this.token,
        useCorsProxy: this.useCorsProxy 
      };
    } catch (error) {
      console.error('Error initializing API configuration:', error);
      return { baseURL: '', apiKey: '', token: '', useCorsProxy: false };
    }
  }
};
